/**
 * Analytics abstraction for plcy.io public website.
 * Currently uses Google Analytics 4 (gtag.js).
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

/**
 * Track a waitlist email signup conversion.
 */
export function trackWaitlistSignup(source = 'coming-soon'): void {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'sign_up', {
      method: 'waitlist',
      source,
    });
  }
}

/**
 * Track a custom event.
 */
export function trackEvent(
  eventName: string,
  params?: Record<string, string | number | boolean>
): void {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
}
